export const SUSY_AUTH_USER_PROJECT_PATH = 'susy-auth-user-project-path';

export const unauthenticatedPaths = {
    base: '*',
    home: '/',
    signIn: '/signIn',
    newPassword: '/newPassword/:code',
    resetPassword: '/resetPassword/:code/:email',
    forgotPassword: '/forgotPassword',
    loginWithEmailAndPassword: '/loginWithEmailAndPassword',
    help: '/help/:currentTab',
    invitation: '/invitation/supervisorSignUp/:invitationId',
};

export const sharedPaths = {
    dashboard: 'dashboard',
    changeLog: 'changelog',
    projectDetails: 'projectDetails/:projectId',
    projectVersionHistory: 'projectVersionHistory',
    forcePasswordChange: 'changePassword',
};

export const userPaths = {
    base: '/user/*',
    dashboard: 'dashboard/:currentTab/',
    projectCreate: 'projectCreate/type/:typeId',
    selectProjectType: 'selectProjectType',
    projectUpdate: 'projectUpdate/:projectId',
    projectSelectSupervisor: 'selectSupervisor/:projectId/:currentTab',
    projectSelectSupervisorWithSuggestedSupervisor:
        'preselectSupervisor/:projectId/selectSupervisor/suggestedSupervisor/:suggestedSupervisorId',
    projectHandIn: 'projectHandIn/:projectId',
    archivedProjectDetails: 'archivedProject/:projectId',
    archive: 'archive',
    researchAreas: 'researchAreas',
};

export const supervisorPaths = {
    base: '/supervisor/*',
    researchAreas: 'researchAreas',
    supervisions: 'supervisions/:currentTab',
    grading: 'projectGrading/:id',
    archivedProjectDetails: 'archivedProject/:projectId',
    archive: 'archive',
};

export const adminPaths = {
    base: '/admin/*',
    projects: 'projects/:currentTab',
    supervisors: 'supervisors/:currentTab',
    settings: 'settings/:currentTab/',
    settingsWithSubTab: 'settings/:currentTab/:subTab',
    createEvaluation: 'createEvaluation/:scoringType',
    createEvaluationWithRubricId: 'createEvaluation/:scoringType/:rubricId',
    editEvaluation: 'editEvaluation/:rubricId',
    archivedProjectDetails: 'archivedProject/:projectId',
    archive: 'archive',
    emailItem: 'settings/emails-tab/:emailTemplateId',
};
